"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useWindowDimensions = useWindowDimensions;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _windowDimensionsObserver = _interopRequireDefault(require("../../helpers/WindowDimensionsObserver/windowDimensionsObserver"));
/**
 * Custom hook that tracks window dimensions (width and height) and updates
 * when the window is resized.
 *
 * @returns {{ width: number, height: number }} An object containing the current
 * window width and height in pixels
 *
 * @example
 * ```javascript
 * function MyComponent() {
 *   const { width, height } = useWindowDimensions();
 *
 *   return (
 *     <div>
 *       Window size: {width} x {height}
 *     </div>
 *   );
 * }
 * ```
 */
function useWindowDimensions() {
  var _useState = (0, _react.useState)(function () {
      return _windowDimensionsObserver["default"].width;
    }),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    width = _useState2[0],
    setWidth = _useState2[1];
  var _useState3 = (0, _react.useState)(function () {
      return _windowDimensionsObserver["default"].height;
    }),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    height = _useState4[0],
    setHeight = _useState4[1];
  (0, _react.useEffect)(function () {
    var unsubscribe = _windowDimensionsObserver["default"].subscribe(function (w, h) {
      setWidth(w);
      setHeight(h);
    });
    return function () {
      unsubscribe();
    };
  }, []);
  return {
    width: width,
    height: height
  };
}